import { render, staticRenderFns } from "./GroupConfig.vue?vue&type=template&id=e8680966"
import script from "./GroupConfig.vue?vue&type=script&lang=ts"
export * from "./GroupConfig.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports